import { render } from "./singleaccounting.vue?vue&type=template&id=04a931f4"
import script from "./singleaccounting.vue?vue&type=script&lang=js"
export * from "./singleaccounting.vue?vue&type=script&lang=js"

import "./singleaccounting.vue?vue&type=style&index=0&id=04a931f4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__